import { ButtonSecondary, ButtonType } from '@ui/src';
import { RiskFormWrapperTypes } from './types';

import cn from './risk-form.module.css';

const RiskFormWrapper = ({
  onSubmit,
  children,
  requestInProgress,
  disabled,
}: RiskFormWrapperTypes) => (
  <form className={cn.riskFormWrapper} onSubmit={onSubmit}>
    <div className={cn.riskFormTop}>{children}</div>
    <div className={cn.riskFormBlock}>
      <ButtonSecondary
        type={ButtonType.SUBMIT}
        className={`button-white ${cn.riskFormSubmit}`}
        text={requestInProgress ? 'Loading...' : 'Apply'}
        disabled={disabled}
      />
    </div>
  </form>
);

export default RiskFormWrapper;
